<template>
  <div>
    <div v-if="!editing && !hasErrors">
      <slot name="default" :default-value="getDefaultValue">
        <span v-if="getDefaultValue === null">
          geen waarde bekend
        </span>
        <span v-else-if="type === 'date'">
        {{ getDefaultValue | toDate(DateFormatEnum.DISPLAY_DATE) }}
        </span>
        <span v-else-if="type === 'boolean'">
        {{ getDefaultValue ? 'Ja' : 'Nee' }}
        </span>
        <span v-else-if="type === 'euro'">
        € {{ getDefaultValue }}
        </span>
        <span v-else-if="type === 'percentage'">
        {{ getDefaultValue }} %
        </span>
        <span v-else>
        {{ getDefaultValue }}
        </span>
      </slot>
      <button
          v-if="!onlyShow"
          class="btn btn-sm"
          @click="startEditing"
      >
        wijzig
      </button>
    </div>
    <div v-else>
      <div style="display:flex;flex-direction: row;">
        <slot name="input" :value="getValue" :updateValue="newValue => {this.getValue = newValue}" :default-value="getDefaultValue" :required="required">
          <a-date-picker
              v-model="getValue"
              :placeholder="getDefaultValue"
              :required="required || false"
              v-if="type === 'date'"
              :format="DateFormatEnum.DISPLAY_DATE"
              :value-format="DateFormatEnum.DATE"
          />
          <a-input
              type="number"
              :min="0"
              :max="100"
              :step="0.01"
              v-model="getValue"
              :required="required || false"
              v-else-if="type ==='percentage'"
              suffix="%"
          />
          <a-input
              type="number"
              :min="0"
              v-model="getValue"
              :required="required || false"
              v-else-if="type ==='euro'"
              prefix="€"
          />
          <a-input-number
              :steps="0.1"
              v-model="getValue"
              :required="required || false"
              v-else-if="type ==='float'"
          />
          <a-input-number
              :steps="1"
              v-model="getValue"
              :required="required || false"
              v-else-if="type ==='integer'"
          />
          <select class="form-control" v-model="getValue" v-else-if="type ==='boolean'" :required="required || false">
            <option :value="1">Ja</option>
            <option :value="0">Nee</option>
          </select>
          <select class="form-control" v-model="getValue" v-else-if="type ==='enum'" :required="required || false">
            <option :value="value" v-for="(description, value) in enumOptions">{{ description }}</option>
          </select>
          <a-input
              v-model="getValue"
              :placeholder="getDefaultValue"
              v-else
              :required="required || false"
          />
        </slot>
        <button class="btn btn-sm"
                @click="stopEditing"
                v-if="!isNullButRequired"
        >
          cancel
        </button>
      </div>
      <span class="text-danger" v-if="hasErrors">
        <a-tooltip
            :title="errors.join(', ')"
        >
          Onjuiste waarde gegeven
        </a-tooltip>
      </span>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import {DateFormatEnum} from "~/enums";

export default {
  name: 'EditableValue',
  props: {
    value: {
      required: true,
    },
    defaultValue: {
      default: null,
      type: [String, Number, Boolean, Array],
    },
    type: {
      required: false,
      type: String,
      default: null,
      validator(value) {
        return [null, 'date', 'boolean', 'integer', 'float', 'percentage', 'euro', 'enum'].includes(value)
      }
    },
    errors: {
      required: false,
      type: Array
    },
    enumOptions: {
      required: false,
      type: Object
    },
    required: {
      required: false,
      default: false,
      type: Boolean
    },
    onlyShow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      editing: false,
      moment,
      DateFormatEnum
    }
  },
  mounted() {
    if (this.isNullButRequired) {
      this.editing = true;
    }
  },
  methods: {
    stopEditing() {
      this.editing = false;
      this.getValue = null;
    },
    startEditing() {
      this.editing = true;
      this.getValue = this.getDefaultValue;
    },
    transform(original) {
      if (!original) return original;

      if (original === this.NULL_BUT_REQUIRED || original === this.OPTIONAL) return null;

      if (this.type === 'percentage') {
        return String(Math.round(original * 10000) / 100);
      } else {
        return String(original);
      }
    },
    transformBack(value) {
      if (!value) return value;

      if (this.type === 'percentage') {
        return String(value / 100);
      } else {
        return String(value);
      }
    }
  },
  computed: {
    getValue: {
      get() {
        return this.transform(this.value);
      },
      set(newValue) {
        this.$emit('change', this.transformBack(newValue));
      }
    },
    getDefaultValue() {
      let defaultValue = this.transform(this.defaultValue);

      if (this.type === 'enum' && this.enumOptions.hasOwnProperty(defaultValue)) {
        defaultValue = this.enumOptions[defaultValue];
      }

      return defaultValue;
    },
    isNullButRequired() {
      return this.defaultValue === null && this.required;
    },
    hasErrors() {
      return this.errors && this.errors.length > 0;
    }
  }
}
</script>

<style scoped>

</style>
